import { useEffect, useRef } from 'react';

import { useTranslation } from '@shared/i18n';
import { delay } from '@shared/utils/delay';

import { MessageLayout } from 'component/layout/MessageLayout';
import { useAppMode } from 'component/root/AppModeProvider';

const REDIRECT_DELAY = 4000;

export function NotFoundMessage() {
  const { t } = useTranslation();
  const { isSdk } = useAppMode();
  const hasLoggedSdkError = useRef(false);

  useEffect(() => {
    if (isSdk) {
      if (!hasLoggedSdkError.current) {
        hasLoggedSdkError.current = true;
        console.error('SDK initialized with incorrect siteId');
        console.error('siteId does not match any available site');
      }

      return;
    }

    let cancelled = false;

    delay(REDIRECT_DELAY).then(() => {
      if (cancelled) {
        return;
      }

      window.location.href = '/n/sites';
    });

    return () => {
      cancelled = true;
    };
  }, [isSdk]);

  const message = isSdk
    ? t('redirects.error_page.sdk_missing_params_error')
    : t('redirects.page_not_found_error');

  return <MessageLayout message={message} hasLoader={!isSdk} />;
}
